import { useCmmInputUniqueValuesContext } from "../../../../../../../context/cmmInputUniqueValuesContext";

/**
 * Hook to access CMM input unique values from context.
 * Must be used within the Validation Funnel layout (under CmmInputUniqueValuesProvider).
 * Data is fetched from /flagging_algorithm_config/cmm_input_unique_values when the layout mounts.
 */
export const useCmmInputUniqueValues = () => {
  const context = useCmmInputUniqueValuesContext();
  return {
    cmmInputUniqueValues: context.cmmInputUniqueValues,
    cmmInputUniqueValuesTableData: context.cmmInputUniqueValuesTableData,
    loading: context.loading,
    error: context.error,
    refetch: context.refetch,
    updateShowOnList: context.updateShowOnList,
    saveTopValues: context.saveTopValues,
  };
};
